// The red/amber/green tone for the platform's internal cost-floor advisory (never customer-facing;
// see costFloor/costFloorStatus in server/src/modules/quotes/pricing.ts). Office-only and advisory
// only: nothing that reads this changes what the office may do. Session AJQ built this for the
// renewal frequency-change panel; Session AJR reuses it verbatim for the renewals-due morning
// action rather than inventing a second copy, per the platform's own rule against two homes for one
// lookup table. The same red/amber/green language as the Lifts register's three-band status
// (liftStatus.ts's LIFT_TONE_META) -- "action needed / due soon / up to date" -- so the office reads
// one consistent colour vocabulary everywhere in the app.
//
// Session AUP (design system Session 7b): the pill is drawn by StatusPill's literal form, so the
// entry carries a PillTone instead of a class string and a hex dot.
import type { PillTone } from "../components/StatusPill";

export const COST_FLOOR_TONE: Record<"below" | "tight" | "ok", { word: string; tone: PillTone }> = {
  below: { word: "Below cost floor", tone: "red" },
  tight: { word: "Tight against cost floor", tone: "amber" },
  ok: { word: "Comfortably above cost floor", tone: "green" },
};
